import type { ComponentTemplateHeadCellContent } from 'models/CommentTemplate';
import type { HeadCell } from 'models/TableProps';

export const COMMENT_TEMPLATE_HEAD_CELLS: HeadCell<ComponentTemplateHeadCellContent>[] =
    [
        {
            id: 'id',
            label: 'ID',
            sortable: true,
            numeric: false,
            disablePadding: false,
        },
        {
            id: 'title',
            label: 'TITLE',
            sortable: true,
            numeric: false,
            disablePadding: false,
        },
        {
            id: 'created_at',
            label: 'CREATED_AT',
            sortable: true,
            numeric: false,
            disablePadding: false,
        },
        {
            id: 'updated_at',
            label: 'UPDATED_AT',
            sortable: true,
            numeric: false,
            disablePadding: false,
        },
        {
            id: 'more',
            label: 'MORE',
            sortable: false,
            numeric: true,
            disablePadding: false,
        },
    ];
